<template>
<div>
    <div v-show="this.$route.name==='Login' || this.$route.name==='not found' ? true : false"
      class="default-header">
      <img alt="teleflex logo" class="logo" :src=logoSrc >
          <span class="tagline">Project Expenditure Authorization (PEA)</span>
    </div>

    <div v-show="this.$route.name==='Login' || this.$route.name==='not found' ? false : true">
      <el-row class="topRow">
        <img alt="teleflex logo" class="logo" :src=logoSrc>
        <span class="tagline">Project Expenditure Authorization (PEA)</span>
        <div class="userMenu adminMenu">
          <el-menu :default-active="activeIndex" mode="horizontal" :router="true" style="z-index:50" background-color="white" >
            <el-menu-item v-show="this.getAdminStatus() || this.isServiceDesk" index="24"  :route="{name:'AdminArea'}">
              Admin
            </el-menu-item>
            <el-submenu index="30" style="float: right !important;" class="loginMenu">
              <template slot="title">{{fullName}}</template>
              <el-menu-item index="30-2" @click.native="logout()">Log Out</el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </el-row>
      <el-row v-if="usingIE" class="IEmessage">
        <el-col>
          <strong>Internet Explorer does not provide an optimal experience. Please consider using a different browser.</strong>
        </el-col>
      </el-row>
      <el-row class="menuRow" style="background-color: #eef1f6 !important">
        <el-menu text-color="black" background-color="white"  mode="horizontal" :router="true" style="z-index:50">
          <el-menu-item  class="grey-header"  index="1" :route="{path: '/'}">
            Home
          </el-menu-item>
          <el-submenu  index="5">
            <template slot="title">
              <router-link :to="{path: '/createPEA'}">
                Create
              </router-link>
            </template>
            <el-menu-item index="5-1" :route="{path: '/createPEA'}">
              New PEA
            </el-menu-item>
            <el-submenu index="5-2" >
              <template slot="title">Copy from existing</template>
              <div v-for="(item) in statusList"  :key="item.id">
                <el-menu-item  :index="'5-2-' +'' + item.id + ''" :route="{path: '/clonePEAs/status/' + item.id}">
                  {{ item.description }}
                </el-menu-item>
              </div>
            </el-submenu>
          </el-submenu>
          <el-submenu index="10">
            <template slot="title">
              <router-link :to="{path: '/my-peas/status/7'}">
                My PEAs
              </router-link>
            </template>
            <div v-for="(item) in statusList" :index="'10-' +'' + item.id + ''" :key="item.id">
              <el-menu-item :index="'10-' +'' + item.id + ''" :route="{path: '/my-peas/status/' + item.id}">
                {{ item.description }}
              </el-menu-item>
            </div>
          </el-submenu>
          <el-submenu index="11">
            <template slot="title">
              <router-link :to="{path: '/my-approvals/1'}">
                My Approvals
              </router-link>
            </template>
            <el-menu-item index="11-1" :route="{path: '/my-approvals/1'}">
              Still Required
            </el-menu-item>
            <el-menu-item-group title="Given">
              <el-menu-item index="11-2" :route="{path: '/my-approvals/2'}"  class="grouped-menu">
                Awaiting Other Approvals
              </el-menu-item>
              <el-menu-item index="11-3" :route="{path: '/my-approvals/3'}"  class="grouped-menu">
                Fully Approved
              </el-menu-item>
              <el-menu-item index="11-4" :route="{path: '/my-approvals/4'}"  class="grouped-menu">
                Withdrawn
              </el-menu-item>
              <el-menu-item index="11-5" :route="{path: '/my-approvals/5'}"  class="grouped-menu">
                Cancelled
              </el-menu-item>
              <el-menu-item index="11-6" :route="{path: '/my-approvals/6'}" class="grouped-menu" >
                Denied
              </el-menu-item>
              <el-menu-item index="11-7" :route="{path: '/my-approvals/7'}" class="grouped-menu">
                Denied With Conditions
              </el-menu-item>
              <el-menu-item index="11-8" :route="{path: '/my-approvals/8'}" class="grouped-menu">
              Complete
              </el-menu-item>
              <el-menu-item index="11-9" :route="{path: '/my-approvals/0'}" class="grouped-menu">
                All
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="15">
            <template slot="title">
              <router-link :to="{path: '/all-peas/status/7'}">
                All PEAs
              </router-link>
            </template>
            <div v-for="(item) in statusList" :key="item.id" >
              <el-menu-item :index="'15-' + ''+ item.id + ''" :route="{path: '/all-peas/status/' + item.id}">
                {{ item.description }}
              </el-menu-item>
            </div>
          </el-submenu>
          <el-submenu index="20">
            <template slot="title">
              <router-link :to="{path: '/search'}">
                  Tools
              </router-link>
            </template>
            <el-menu-item index="20-1" :route="{path: '/search'}">
              Search
            </el-menu-item>
            <el-menu-item index="20-2" :route="{path: '/viewPEAApprovalRolesAndUsers'}">
              PEA Approver List
            </el-menu-item>
            <el-menu-item-group title="Grouping Reports">
              <el-menu-item index="20-3" :route="{path: '/reports/standard-grouping'}" class="grouped-menu">
                Standard Grouping Reports
              </el-menu-item>
              <el-menu-item index="20-4" :route="{path: '/reports/custom-grouping'}" class="grouped-menu">
                Custom Grouping Reports
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="25">
            <template slot="title">
              <a href="https://home.teleflex.com/Intranet/TeleflexIncorporated/PEADocumentation/" target="_blank">
                  Help
              </a>
            </template>
              <a href="https://home.teleflex.com/Intranet/TeleflexIncorporated/PEADocumentation/" target="_blank">
                <el-menu-item>FAQ
                </el-menu-item>
              </a>
              <a href="https://home.teleflex.com/Intranet/TeleflexIncorporated/departments/IT/GlobalITContacts.html" target="_blank">
                <el-menu-item>
                  Support
                </el-menu-item>
            </a>
          </el-submenu>
        </el-menu>
      </el-row>
    </div>
  </div>
</template>

<script>
import router from '../../router'
// eslint-disable-next-line
import store from '../../state/store.js'
import {statusList} from '@/components/utility/statusList.js'
import helperMethods from '@/components/utility/helperMethods.js'
import axios from '@/plugins/axios.js'
import teleflexLogo from '@/assets/header/Teleflex_Corporate Logo_RGB_Navy.svg'
export default {
  name: 'header-component',
  mixins: [statusList],
  data () {
    return {
      usingIE: false,
      activeIndex: '1',
      account: this.$store.state.userInfo.account,
      logoSrc: teleflexLogo
    }
  },
  computed: {
    fullName () {
      return this.$store.getters.fullName
    },
    isServiceDesk () {
      return this.$store.getters.isServiceDesk
    }
  },
  methods: {
    async logout () {
      await this.$msalInstance
        .logoutPopup({ mainWindowRedirectUri: process.env.BASE_URL + '/login?unauthorized=2' })
        .then(() => {
          delete axios.defaults.headers.common['Authorization']
          this.$emitter.emit('logout', 'logging out')
        })
        .catch((error) => {
          console.error(error)
        })
    },
    goTo (destination) {
      router.push(destination)
    },
    checkIE () {
      var browser = helperMethods.getBrowser()
      if (browser.name === 'MSIE' || browser.name === 'IE') {
        this.usingIE = true
      }
    },
    getAdminStatus () {
      return this.$store.getters.isAdmin
    }
  },
  created: function () {
    this.checkIE()
  }
}

</script>

<style>
  .IEmessage {
    padding: 0 42px;
    background: white;
    border-bottom: 2px solid #ddd;
    color: rgb(165,0,33);
  }
  #mainContent {
    padding-top: 200px;
  }

#mainMenu .el-submenu__title, #mainMenu .el-menu-item {
    float: left;
}
  #mainMenu {
    position: absolute;
    width: 100%;
    z-index: 1000;
    transition: box-shadow .25s;
  }

  #mainMenu .topRow, #mainMenu .menuRow {
    padding: 0 20px;
  }

  #mainMenu .topRow {
    background: white;
    border-bottom: 2px solid #ddd;
  }

  #mainMenu .userMenu .el-submenu__title:hover {
    background: white;
  }

  #mainMenu .adminMenu {
    float: right;
  }

  .loginMenu .el-menu {
    right: 10px;
    left: auto !important;
  }

  #mainMenu .loginMenu .el-menu-item:hover {
    background: rgb(238,241,246) !important;
  }

  .logo-block {
    /*background: linear-gradient(to right, #eef1f6 95%,#eef1f6 95%,#d0d6e0 100%);*/
    padding-right: 40px;
  }

  .logo {
    width: 230px;
    height: 95px;
    position: relative;
    top: 0px;
  }

  #mainMenu .topRow .el-menu-item:hover {
    background: white;
  }

  #mainMenu a {
    color: rgb(72,87,106);
  }
  /*.logo g {
    transition: .25s;
  }

  .logo:hover g {
    fill: #00a9ce;
  }*/

  .tagline {
    color: #777;
    font-size: 1.55em;
    position: absolute;
    top: 30px;
    left: 260px;
  }

  #mainMenu .el-submenu__title, #mainMenu .el-menu-item {
    font-weight: bold;
  }

  #mainMenu .menuRow .el-submenu .el-menu-item {
    padding-left: 0;
    padding-right: 0;
  }

  #mainMenu .el-submenu .el-menu-item a {
    padding-left: 20px;
    padding-right: 20px;
    display: block;
  }

  #mainMenu .userMenu .el-submenu__title {
    font-weight: normal;
  }

  #mainMenu .el-menu-item-group__title {
    padding-left: 20px !important;
    font-size: .9em;
    color: black;
    font-weight: bold;
  }

  #mainMenu .el-menu-item-group .el-menu-item {
    padding-left: 40px;
  }
.el-menu-item-group__title {
    padding-left: 10px !important;
    font-weight: bold;
    color: black;
    font-size: 16px;
    }
</style>

<style >

  a:hover {
    text-decoration: none;
  }

  :focus {
    outline: none;
  }
  .grouped-menu {
    padding-left: 20px !important;
  }
  .default-header {
    padding-left: 20px;
    height: 90px;
    background-color: #eef1f6;
  }
  .el-submenu__title {
      font-weight: 600;
  }
  .menuRow > #mainMenu .el-submenu__title{
    background-color:#eef1f6 !important;
  }
  .grey-header {
    background-color:#eef1f6 !important;
  }
  .menuRow > .el-menu--horizontal>.el-submenu .el-submenu__title {
    background-color:#eef1f6 !important;
  }
  #mainMenu .el-menu--horizontal {
    background-color:#eef1f6 !important;
  }
  .el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: 2px !important;
  }
  .el-menu-item.is-active {
    border-bottom: 0px !important;
  }
</style>
